import styled from "@emotion/styled";
import { AppearAnimator, MDSListBox, MDSSection, MDSText, MDSTextVariant } from "@/mds";

export const StyledPageWrapper = styled(AppearAnimator)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

export const StyledContentWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[2],
  fontSize: theme.fontSizes["paragraph-s"],
  lineHeight: theme.lineHeights["paragraph-s"],
  alignItems: "flex-start",
  color: theme.colors.text.primary,
  flex: "1 0 0",
  overflow: "auto",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  padding: theme.spacing[7],
}));

export const StyledContentSectionTitleWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing["2"],
  color: theme.colors.text.contrast,
  fontSize: theme.fontSizes["header-s"],
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: theme.lineHeights[MDSTextVariant.HeaderS],
  letterSpacing: "-0.2px",
  margin: 0,

  "& img": {
    width: "16px",
    height: "16px",
  },
}));

export const StyledCardIntegrationInstruction = styled(MDSSection)`
  display: flex;
  width: 784px;
  padding: ${({ theme }) => theme.spacing[5]} 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing["3"]};
`;

export const StyledContentList = styled.ul(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[1],
  margin: 0,
  padding: `0 ${theme.spacing[5]} 0 ${theme.spacing[10]}`,
  fontSize: theme.fontSizes["text-m"],
  color: theme.colors.text.primary,
  lineHeight: theme.lineHeights["paragraph-sm"],
  alignItems: "flex-start",
  alignSelf: "stretch",

  li: {
    color: theme.colors.text.primary,
    fontSize: theme.fontSizes[MDSTextVariant.ParagraphS],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights[MDSTextVariant.ParagraphS],
  },
}));

export const StyledListBox = styled(MDSListBox)`
  margin-top: ${({ theme }) => theme.spacing[2]};
  margin-left: ${({ theme }) => theme.spacing[5]};
`;

export const StyledContentStatusWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing["1"],
  fontSize: theme.fontSizes["paragraph-s"],
  fontWeight: theme.fontWeights.smedium,
  lineHeight: theme.lineHeights["text-s"],
  color: theme.colors.text.contrast,
}));

export const StyledHeading = styled(MDSText)(({ theme }) => ({
  padding: `${theme.spacing[4]} ${theme.spacing[7]} ${theme.spacing[2]} 0`,
  textTransform: "uppercase",
  letterSpacing: "0.24px",
}));

export const StyledExplanation = styled(MDSText)`
  max-width: 784px;
`;

export const StyledSubTitle = styled(MDSText)``;

export const StyledSubExplanation = styled(MDSText)(({ theme, variant }) => ({
  fontSize: theme.fontSizes["text-s"],
  color: theme.colors.text.secondary,
  lineHeight:
    variant === MDSTextVariant.ParagraphS
      ? theme.lineHeights["paragraph-s"]
      : theme.lineHeights["text-s"],
  margin: 0,
}));

export const StyledContentListTextContainer = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing[1],
}));

export const StyledFormattingContentLeftAddon = styled.div`
  margin-top: ${({ theme }) => theme.spacing["2"]};
`;

export const StyledFormattingContentRightAddon = styled.div``;
